import { ILocale } from 'types';
import { trackEvent } from '..';
import { COMPONENT, PRODUCT_EVENT } from '../constants';
import { getIDetailsGeneric } from './genericEvents';

interface EventShareTooltipProps {
	cruise: any;
	cruiseIndex?: number;
	resultsLength?: number;
	locale: ILocale;
	component: string;
}

const trackOnShareTooltip = ({ cruise, cruiseIndex, resultsLength, locale, component }: EventShareTooltipProps) => {
	const action = `${component}: ${component === COMPONENT.roomViewPanel ? 'cruise: ' : ''}${PRODUCT_EVENT.favorite.shared}`;

	const event = {
		...getIDetailsGeneric({ cruise, cruiseIndex, resultsLength, locale, action }),
		productEvent: [PRODUCT_EVENT.favorite.shared],
	};

	trackEvent(event);
};

export { trackOnShareTooltip };
